<template>
  <section v-if="project">
    <div class="tip" style="margin:0 0 0 20px">* 基本资料</div>
    <div class="clear">
      <el-form-item label="项目/合同名称">
        <el-input size="small" v-model="project.name" :disabled="true" placeholder="请输入项目名称"></el-input>
      </el-form-item>
    </div>

    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目需求单位">
          <el-input size="small" placeholder="项目需求单位" :disabled="true" v-model="project.deptName"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="代理单位">
          <el-input size="small" placeholder="代理单位" v-model="form.dldw"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item class="underline-label" label="已线下通过该审批" >
      <el-radio v-model="form.underLine" label="1">是</el-radio>
      <el-radio v-model="form.underLine" label="0">否</el-radio>
      <p class="tip" v-if="form.underLine=='1'" style="padding:0 10px;border:1px #d93c37 solid;">*已线下通过的审批须在附件中上传原始审批文件或三重一大会议纪要等相关证明文件，方便领导批阅。</p>
    </el-form-item>
    <div class="clear">
      <!-- <el-col :span="12"> -->
        <el-form-item label="招标内容">
          <el-input size="small" placeholder="招标内容" v-model="form.content"></el-input>
        </el-form-item>
      <!-- </el-col> -->
      <el-col :span="12">
        <el-form-item label="招标方式">
          <el-select size="small" v-model="form.mode" placeholder="请选择">
            <el-option v-for="item in modeArr" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </div>

  </section>
</template>

<script>
  export default {
    props: ['project', 'formByFather', 'userData', 'teamArr', 'projectArr'],
    data() {
      return {
        form: {
          projectId: '',
          dldw: "",
          content: "",
          mode: "",
        },
        modeArr: ['子公司自行采购', '集团自行招标', '公开招标', '其他']
      }
    },
    mounted() {
      this.form = this.formByFather

      // this.form.depId = this.userData.secDepIds.split(",")[0]
      // this.form.leaderId = this.userData.id
    },
    methods: {
      getFromData() {
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/createInviteApproval.vue